import type { ComponentProps } from "react"
import DropdownMenu from "@/v2-ui/dropdownMenu"

export type ActionMenuProps = ComponentProps<typeof DropdownMenu>

function ActionMenu(props: ActionMenuProps) {
  return <DropdownMenu {...props} />
}

export default ActionMenu
